import React from 'react';
import { Dot } from './Dot';

export type CarouselDotNavType = {
  scrollSnaps: number[];
  selectedIndex: number;
  scrollTo: (index: number) => void;
};

export type CarouselDotType = {
  selected?: boolean;
  onClick: React.MouseEventHandler;
};

export const CarouselDotNav = ({ scrollSnaps, selectedIndex, scrollTo }: CarouselDotNavType) => (
  <div className="flex flex-row justify-center">
    {scrollSnaps.map((_, index) => (
      <Dot
        key={`dot${index.toString()}`}
        isSelected={index === selectedIndex}
        onClickHandler={() => scrollTo(index)}
        ariaLabel={`${index + 1}`}
      />
    ))}
  </div>
);
